import { Button } from "@chakra-ui/react";
import { Table } from "antd";
import { Avatar } from "../../components/Avatar";
import { useState } from "react";
import { transferBatch } from ".";
import { Alert } from "../../components/Alert";
import { formatCurrency, formatDate, showToast } from "../../utils";
import { ColumnsType } from "antd/lib/table";
import { useTransfer } from "../../hooks/useTransfer";

interface ApprovalParams {
  authorizeTransfers: Array<transferBatch>;
  ref: any;
}

interface DeleteModalParams {
  uuid: string;
  sellerName: string;
  amount: number;
}

export function Approval({
  authorizeTransfers,
  ref
}: ApprovalParams) {
  const { deleteAuthorize } = useTransfer();
  const [deleteModalState, setDeleteModalState] = useState<boolean>(false);
  const [deleteModalParamsState, setDeleteModalParamsState] = useState<DeleteModalParams>();
  const [isDeleteLoading, setIsDeleteLoading] = useState<boolean>(false);
  const approval: ColumnsType<any> = [
    {
      key: "sellerName",
      title: "Seller",
      dataIndex: "sellerName",
      render: (sellerAccountancy, record) => (
        <p>
          <Avatar name={record?.sellerName} />
        </p>
      )
    },
    {
      key: "creationDate",
      title: "Data Criação",
      dataIndex: "creationDate",
      render: (creationDate, record) => (
        <p>{formatDate(record?.createDate)}</p>
      )
    },
    {
      key: "pixKey",
      title: "PIX",
      dataIndex: "pixKey",
      render: (pixKey, record) => (
        <p>{record?.pixKey}</p>
      )
    },
    {
      key: "amount",
      title: "Saldo",
      dataIndex: "amount",
      render: (amount, record) => (
        <p>{formatCurrency({ value: record?.amount })}</p>
      )
    },
    {
      key: "button",
      title: "",
      dataIndex: "button",
      render: (item, record) => (
        <Button
          variant="ghost"
          color="#FF4D4F"
          fontWeight="400"
          onClick={() => handleOpenDeleteTransferModal(record)}
        >
          Excluir
        </Button>
      )
    }
  ]
  async function handleDelete() {
    try {
      setIsDeleteLoading(true);
      await deleteAuthorize(deleteModalParamsState?.uuid);
      showToast({
        type: "success",
        message: "Repasse excluído com sucesso!"
      });
      window.location.reload();
    } catch (error) {
      error?.response?.data?.errors?.map((error:any) => (
        showToast({
            type: "error",
            message: `${error?.code} - ${error?.description}`
        })
      ));
    } finally {
      setIsDeleteLoading(false);
      setDeleteModalState(!deleteModalState);
    }
  }
  function handleOpenDeleteTransferModal(record: any) {
    setDeleteModalParamsState({
      uuid: record?.uuidTransferBatch,
      sellerName: record?.sellerName,
      amount: record?.amount
    });
    setDeleteModalState(!deleteModalState);
  }
  return (
    <>
      <Alert 
        isOpen={deleteModalState}
        onClose={() => setDeleteModalState(!deleteModalState)}
        title="Tem certeza de que deseja excluir o repasse?"
        messageBody={`Deseja excluir o repasse de ${formatCurrency({value: deleteModalParamsState?.amount})} para ${deleteModalParamsState?.sellerName}?`}
        confirmButtonText="Excluir"
        closeButtonText="Cancelar"
        onConfirm={handleDelete}
        leastDestructiveRef={ref}
        isLoading={isDeleteLoading}
      />
      <Table<any>
        columns={approval}
        dataSource={authorizeTransfers}
        rowKey={(record) => record?.key}
        locale={{ emptyText: "Sem repasses a serem aprovados!" }}
      />
    </>
  )
}